import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

function required(name: string): string {
  const env = import.meta.env as Record<string, string | undefined>;
  const raw = env[name];
  if (typeof raw !== "string" || raw.length === 0) {
    throw new Error(
      `Missing required environment variable: ${name}. ` +
        `Ensure it is defined in Infisical and exposed at build time (VITE_*).`
    );
  }
  return raw;
}

export const env = {
  authority: required("VITE_ZITADEL_AUTHORITY"),
  clientId: required("VITE_ZITADEL_CLIENT_ID"),
  projectId: required("VITE_ZITADEL_PROJECT_ID"),
  orgId: required("VITE_OPENSESAME_ORG_ID"),
  redirectUri: required("VITE_REDIRECT_URI"),
  postLogoutRedirectUri: required("VITE_POST_LOGOUT_REDIRECT_URI")
} as const;

const scope = [
  "openid",
  "profile",
  "email",
  "urn:zitadel:iam:user:resourceowner",
  "urn:zitadel:iam:org:projects:roles",
  `urn:zitadel:iam:org:project:id:${env.projectId}:aud`
].join(" ");

export const oidcConfig: AuthProviderProps = {
  authority: env.authority,
  client_id: env.clientId,
  redirect_uri: env.redirectUri,
  post_logout_redirect_uri: env.postLogoutRedirectUri,
  response_type: "code",
  scope,
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, "/");
  }
};
